import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'webshop-wrapper',
  template: `
    <webshop (onSaved)="onWebshopSaved($event)" (onCancel)="onDialogCancel()" [showAsDialog]="true" [webshopId]="webshopId"></webshop>
  `
})
export class WebshopWrapperComponent {
  @Input() public webshopId:string;

  @Output() public onSaved:EventEmitter<{ id: number }> = new EventEmitter();
  @Output() public onCancel:EventEmitter<void> = new EventEmitter();

  public onWebshopSaved(webshopId:number):void {
    this.onSaved.emit({ id : webshopId });
  }

  public onDialogCancel():void {
    this.onCancel.emit();
  }
}